import { Loader2, Play } from "lucide-react";
import { toast } from "sonner";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableHeader, TableHead, TableBody, TableRow, TableCell } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { useCronJobs, useTriggerCron } from "@/hooks/api";

export function CronTab() {
  const cronJobs = useCronJobs();
  const triggerCron = useTriggerCron();

  const handleTrigger = async (worker: string) => {
    try {
      await triggerCron.mutateAsync({ worker });
      toast.success(`Cron-jobb "${worker}" trigget`);
    } catch (err: any) {
      toast.error(err.message || "Feil ved triggering");
    }
  };

  return (
    <div className="space-y-4 mt-4">
      <Card>
        <CardContent className="pt-4">
          {cronJobs.isLoading ? (
            <div className="flex justify-center py-8"><Loader2 className="h-6 w-6 animate-spin" /></div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Navn</TableHead>
                  <TableHead>Worker</TableHead>
                  <TableHead>Beskrivelse</TableHead>
                  <TableHead>Tidsplan</TableHead>
                  <TableHead></TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {(cronJobs.data ?? []).map((cron: any) => (
                  <TableRow key={cron.worker}>
                    <TableCell className="font-medium">{cron.name}</TableCell>
                    <TableCell className="font-mono text-xs">{cron.worker}</TableCell>
                    <TableCell className="text-xs text-admin-text-secondary max-w-xs">{cron.description}</TableCell>
                    <TableCell className="text-xs">{cron.schedule}</TableCell>
                    <TableCell>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => handleTrigger(cron.worker)}
                        disabled={triggerCron.isPending}
                      >
                        <Play className="h-3 w-3 mr-1" /> Trigger
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
                {(cronJobs.data ?? []).length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5} className="text-center text-admin-text-secondary py-8">Ingen cron-jobber registrert</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
